import type { AxiosError } from 'axios';
import { HttpErrorStatus } from '@/shared/legacy/api/http-error';

export function isEmptyReportError(err: AxiosError) {
  type ErrorResponseData = {
    errors?: {
      common?: Array<string>;
    };
  };
  const data = err.response?.data as ErrorResponseData;
  const reason = data?.errors?.common?.[0];
  const statusCode = err.response?.status;

  return statusCode === HttpErrorStatus.BAD_REQUEST
    && (reason === 'error.reports.survey_type_a.empty_report'
      || reason === 'error.reports.survey_type_q.empty_report');
}
